module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Euro-65128226ac8d3640b61f86984c5a7101.svg";